class ContentTracking {
    constructor(id, status, state)   {
        this.id = id;
        this.status = status;
        this.state = state || {};
    }
}

export default ContentTracking;